import { render, staticRenderFns } from "./ListMinimal.vue?vue&type=template&id=05a60080"
import script from "./ListMinimal.vue?vue&type=script&lang=js"
export * from "./ListMinimal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports